<app-data-grid-comp
    [columns]="columns"
    hideActionButtons="true"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    [sortable]="{
        mode: 'multiple'
    }"
    [sort]="sort"
    [sortableColumns]="sortableColumns"
    searchable="true"
    (emitSearchEvent)="search($event)"
    [filterCategories]="filterCategories"
    (emitFilterEvent)="filterCallback($event)"
    category=""
    [rowSelectionSettings]="rowSelectionSettings"
    clickableRows="true"
    [clearSelectedItems]="clearSelectedItems"
    [rowActionButtons]="gridActionButtons"
    (rowActionEvent)="goToEditReport($event)"
    (emitPageChangeEvent)="pageChange($event)"
    (emitSortEvent)="sortChange($event)"
    (emitOpenDialogEvent)="goToRenderReport($event)"
    (emitDeleteEvent)="deleteAllSelected($event)"
></app-data-grid-comp>
